export const POS_MAPPING = {
    'TW': 'Torwart',
    'RV': 'Verteidigung', 'IV': 'Verteidigung', 'LV': 'Verteidigung',
    'RAV': 'Verteidigung', 'LAV': 'Verteidigung',
    'ZDM': 'Mittelfeld', 'ZM': 'Mittelfeld', 'ZOM': 'Mittelfeld',
    'RM': 'Mittelfeld', 'LM': 'Mittelfeld',
    'RF': 'Mittelfeld', 'LF': 'Mittelfeld', 'ST': 'Sturm'
};

export const splitPlayersForPosition = (players, posName, stats) => {
    const category = POS_MAPPING[posName] || '';
    const statMap = stats || {};

    const preferred = [];
    const others = [];
    for (const p of players) {
        if (p.preferred_positions?.includes(category)) {
            preferred.push(p);
        } else {
            others.push(p);
        }
    }

    const sortFn = (a, b) => {
        const aPos = statMap[a.id]?.[category] ?? 0;
        const bPos = statMap[b.id]?.[category] ?? 0;
        if (bPos !== aPos) return bPos - aPos;

        const aTrain = statMap[a.id]?.trainings ?? 0;
        const bTrain = statMap[b.id]?.trainings ?? 0;
        return bTrain - aTrain;
    };

    preferred.sort(sortFn);
    others.sort(sortFn);

    return { preferred, others };
};

export const playerLabel = (p) =>
    `${p.first_name} ${p.last_name[0]}.${p.isGast ? ' (Gast)' : ''}`;

export const getInitials = (playerId, players) => {
    if (!playerId) return '';
    const p = players.find(x => x.id === playerId);
    if (!p) return '';
    if (p.isGast) return `${p.first_name[0]}.(G)`;
    return `${p.first_name[0]}.${p.last_name ? p.last_name[0] + '.' : ''}`.toUpperCase();
};
